import React from "react";
import { SocialMedia } from "./components/social-media";
import { Menu } from "@default/general-components/navigation/menu";
import RBXAnimation from "../general-components/rbx-animation/rbx-animation";
import PropTypes from "prop-types";
import AccessibilityIcon from "../../assets/ui/accessibility-logo-white.svg?url";
import FooterPartners from "@default/js/footer/components/footer-partners";
import Image from "./../general-components/image/image";
import LazyLoad from "react-lazyload";
import { useSelector } from "react-redux";

const Footer = ({ footerConfig, socialMediaConfig }) => {
  const currentLanguage = useSelector(
    (reduxStore) => reduxStore.i18n.currentLanguage
  );

  return (
    <div className="container">
      {footerConfig && (
        <div className="row">
          <div className={"col-12 col-lg-6 footer logo"}>
            {footerConfig.fieldFooterLogo ? (
              <Image
                data={footerConfig.fieldFooterLogo.fieldMediaImage}
                className="footer-logo"
              />
            ) : (
              <LazyLoad offset={500}>
                <RBXAnimation className="loading-animation" />
              </LazyLoad>
            )}
          </div>
          <div className="col-12 col-lg-6 footer links">
            <div className="footer-menu row">
              {!!footerConfig.fieldFooterMenu?.links.length && (
                <div className="col-12 col-lg-6">
                  <Menu
                    menuTree={footerConfig.fieldFooterMenu}
                    ariaLabel={"footer menu"}
                  />
                </div>
              )}

              <div className="col-12 col-lg-6">
                {currentLanguage !== "en" && (
                  <>
                    <img
                      src={AccessibilityIcon}
                      alt={"Button: Infos zur Barrierearmut"}
                      className="accessibility-icon"
                    />
                    <Menu
                      menuName={"ACCESSIBILITY_MENU"}
                      ariaLabel={"assessibility menu"}
                    />
                  </>
                )}
              </div>
            </div>

            {socialMediaConfig && (
              <div className="row footer-social-media">
                <div className="col-12">
                  <h3 className="headline">Socials</h3>
                </div>
                <SocialMedia content={socialMediaConfig} />
              </div>
            )}

            <FooterPartners content={footerConfig} />
          </div>
        </div>
      )}
    </div>
  );
};

Footer.propTypes = {
  footerConfig: PropTypes.object,
  socialMediaConfig: PropTypes.object,
};

export default Footer;
